import type { Assign } from '@ark-ui/react'
import { Field as ArkField } from '@ark-ui/react/field'
import { forwardRef } from 'react'
import { cn } from '~/utils/cn'
import type { InputTextSharedProps } from './input-text-root'

export type InputTextLabelProps = Assign<
  React.ComponentProps<typeof ArkField.Label>,
  InputTextSharedProps & {
    readOnly?: boolean
    disabled?: boolean
  }
>

export const InputTextLabel = forwardRef<HTMLLabelElement, InputTextLabelProps>(
  ({ children, size = 'ml', disabled, readOnly, ...props }, ref) => {
    if (!children) return null

    return (
      <div className="flex h-extrasmall w-[100%] items-center rounded-none border-none px-onepulse text-left">
        <ArkField.Label
          ref={ref}
          className={cn(
            'w-[100%] align-middle m-none p-none text-left font-rdmodern font-regular tracking-tiny text-text-neutral text-nowrap truncate leading',
            {
              'text-threepulse': size === 'md',
              'text-threeandhalfpulse':
                size === 'ml' || size === 'lg' || size === 'xl',
              'cursor-not-allowed text-text-neutral-disabled': disabled,
              'cursor-not-allowed text-text-neutral-readonly':
                readOnly && !disabled,
            }
          )}
          aria-disabled={disabled}
          {...props}
        >
          {children}
        </ArkField.Label>
      </div>
    )
  }
)

InputTextLabel.displayName = 'InputTextLabel'
